import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const IntegrationSettings = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Entegrasyon Ayarları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Entegrasyon ayarları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default IntegrationSettings;
